/*! DPRD-Semantic-Analytics-Framework - v3.11.32 - 2017-02-08 */
(function () {
(function () {
var mboxCopyright = "Copyright 1996-2015. Adobe Systems Incorporated. All rights reserved.";

/* WDPRO Additions */
var tnt_wdpro = {
    aMboxTargets: [],
    // tnt_wdpro.aMboxTargets Hashmap [strMboxName: nodeMBoxElement]
    aMboxTargetsState: [],
    aMboxes: [],
    seenCmpCookie: 'wdpro_seen_cmps',
    // getElement
    // @desciption returns an element via a selector, such as 'jQuery(".home-panel > .bd div:nth-child(4)").get(0)', or by element id
    // @param strTarget Either a query or an element id
    getElement: function(strTarget) {
        if (!!strTarget) {
            if (strTarget.indexOf('(') > -1) {
                return new Function('return ' + strTarget)();
            } else {
                return document.getElementById(strTarget);
            }
        } else {
            return false;
        }
    },
    // moveContent
    // @description removes content of an element and inserts new content
    // @param strMboxName mBox name used to lookup the target DOM element.
    // @param nodeTarget The node to insert into the DOM.
    moveContent: function(strMboxName, nodeTarget) {
        var newContent = tnt_wdpro.aMboxes[strMboxName];

        if (!!nodeTarget && typeof nodeTarget === 'object' && !!newContent && typeof newContent === 'object') {

            //only perform move if TnT returned new content
            if (newContent.className !== "mboxDefault") {
                // Enumerate mBox hashmap to move imported content into targeted location
                if (nodeTarget.hasChildNodes()) {
                    while (nodeTarget.childNodes.length >= 1) {
                        nodeTarget.removeChild(nodeTarget.firstChild);
                    }
                }
                // Put imported content div inside target element
                nodeTarget.appendChild(newContent);
            }
            tnt_wdpro.showMboxTargetDivs(strMboxName, nodeTarget);
        }
    },
    // tnt_wdpro.pollTargetElement
    // @description polls until a dom element is found and runs a callback funtion when found
    pollTargetElement: function(strMboxName, callbackFunction) {

        var checkForElement, target, intCounter = 0,
            nIntervalId;

        checkForElement = function() {
            intCounter += 1;
            target = tnt_wdpro.getElement(tnt_wdpro.aMboxTargets[strMboxName]);
            if (target) {
                clearInterval(nIntervalId);
                callbackFunction(strMboxName, target);
            } else if (intCounter > 20) {
                clearInterval(nIntervalId);
            }
        };
        nIntervalId = setInterval(checkForElement, 50);
    },
    /**
     *    hideMboxTargetDivs
     *    Hides all divs that are going to get content from Tnt to avoid flicker.
     *    Mbox.js automatically unhides the div when the content is placed
     */
    hideMboxTargetDivs: function(strMboxName, target) {

        if (!!target && tnt_wdpro.aMboxTargetsState[strMboxName] !== 'visible') {
            target.style.visibility = 'hidden';
        }
    },
    showMboxTargetDivs: function(strMboxName, nodeTarget) {
        if (!!nodeTarget && typeof nodeTarget === 'object') {
            tnt_wdpro.aMboxTargetsState[strMboxName] = 'visible';
            nodeTarget.style.visibility = 'visible';
        }
    },
    setCookie: function(name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
        document.cookie = name + "=" + c_value + '; path=/';
    },
    // get/parse cookies
    getCookie: function(sName) {
        // reset boolean
        var g_bCookieFound = false;

        // split cookie into name/value pairs
        var aCookies = document.cookie.split(';'),
            aCookiesLength = aCookies.length,
            aCurrCookie = '',
            cookieName = '',
            cookieValue = '',
            i;

        for (i = 0; i < aCookiesLength; i++) {
            // each position now has a string of the form "name=value".
            // split name and value
            aCurrCookie = aCookies[i].split('=');

            // grab cookie name and value. Make sure there is no leading or trailing white space
            cookieName = aCurrCookie[0].replace(/^\s+|\s+$/g, '');

            // check if this is the cookie we are looking for
            if (cookieName === sName) {
                g_bCookieFound = true;

                // watch out for edge case: the cookie might not have an actual value
                if (aCurrCookie[1].length > 1) {
                    cookieValue = unescape(aCurrCookie[1].replace(/^\s+|\s+$/g, ''));
                }

                return cookieValue;
            }

            // clean up vars for next iteration
            aCurrCookie = null;
            cookieName = '';
            cookieValue = '';
        }
        if (!g_bCookieFound) {
            return null;
        }
    },
    setCampaign: function(campaignId) {
        var seenCmps = tnt_wdpro.getCookie('wdpro_seen_cmps'),
            found = false;

        campaignId = '/' + campaignId.toString() + '/';

        if (!!seenCmps && seenCmps.indexOf(campaignId) === -1) {
            seenCmps += ',' + campaignId;
        } else if (!seenCmps) {
            seenCmps = campaignId;
        }

        tnt_wdpro.setCookie(this.seenCmpCookie, seenCmps, 14);
    },
    getCampaigns: function() {
        return this.getCookie(this.seenCmpCookie);
    }
};
/* End WDPRO Additions */

var TNT = TNT || {};

TNT._internal = (function() {
    return {
        nestedMboxes: [],

        _settings: {
            companyName: "Test&amp;Target",
            isProduction: true,
            adminUrl: "http://admin5.testandtarget.omniture.com/admin",
            clientCode: "disney",
            serverHost: "disney.tt.omtrdc.net",
            mboxTimeout: 10000,
            mboxLoadedTimeout: 100,
            mboxFactoryDisabledTimeout: 30 * 60,
            bodyPollingTimeout: 16,
            sessionExpirationTimeout: 31 * 60,
            experienceManagerDisabledTimeout: 30 * 60,
            experienceManagerTimeout: 5000,
            visitorApiTimeout: 500,
            visitorApiPageDisplayTimeout: 500,
            overrideMboxEdgeServer: true,
            overrideMboxEdgeServerTimeout: 31 * 60,
            tntIdLifetime: 7776000,
            crossDomain: "enabled",
            trafficDuration: 10368000,
            trafficLevelPercentage: 100,
            clientSessionIdSupport: false,
            clientTntIdSupport: false,
            passPageParameters: true,
            usePersistentCookies: true,
            crossDomainEnabled: true,
            crossDomainXOnly: false,
            imsOrgId: "EDA101AC512D2B230A490D4C@AdobeOrg",
            globalMboxName: "target-global-mbox",
            globalMboxLocationDomId: "",
            globalMboxAutoCreate: false,
            experienceManagerPluginUrl: "//cdn.tt.omtrdc.net/cdn/target.js",
            siteCatalystPluginName: "tt",
            mboxVersion: 59,
            mboxIsSupportedFunction: function() {
                return true;
            },
            parametersFunction: function() {
                return "host=" + window.location;
            },
            cookieDomainFunction: function() {
                return mboxCookiePageDomain();
            }
        },

        _params: {
            _page: "mboxPage",
            _marketingCloudVisitorId: "mboxMCGVID",
            _audienceManagerLocationHint: "mboxMCGLH",
            _audienceManagerBlob: "mboxAAMB",
            _analyticsVisitorId: "mboxMCAVID",
            _supplementalDataId: "mboxMCSDID",
            _count: "mboxCount",
            _host: "mboxHost",
            _mboxFactoryId: "mboxFactoryId",
            _tntId: "mboxPC",
            _screenHeight: "screenHeight",
            _screenWidth: "screenWidth",
            _browserWidth: "browserWidth",
            _browserHeight: "browserHeight",
            _browserTimeOffset: "browserTimeOffset",
            _screenColorDepth: "colorDepth",
            _crossDomain: "mboxXDomain",
            _url: "mboxURL",
            _referrer: "mboxReferrer",
            _mboxVersion: "mboxVersion",
            _mboxName: "mbox",
            _mboxId: "mboxId",
            _domLoaded: "mboxDOMLoaded",
            _time: "mboxTime",
            _siteCatalystPluginVersion: "scPluginVersion"
        },

        _pageParams: {
            _disable: "mboxDisable",
            _sessionId: "mboxSession",
            _environment: "mboxEnv",
            _debug: "mboxDebug"
        },

        _cookies: {
            _disable: "disable",
            _sessionId: "session",
            _tntId: "PC",
            _trafficLevel: "level",
            _check: "check",
            _debug: "debug",
            _experienceManagerDisabled: "em-disabled",
            _mboxEdgeServer: "mboxEdgeServer"
        },

        _constants: {
            _defaultFactoryId: "default",
            _cookieNamePrefix: "mbox",
            _divImportPrefix: "mboxImported-",
            _millisInMinute: 60000,
            _divDefaultClass: "mboxDefault",
            _divMarkerPrefix: "mboxMarker-",
            _mboxNameMaxLength: 250,
            _siteCatalystPluginVersion: 1,
            _mboxEdgeServerPrefix: "mboxedge",
            _mboxClusterHostDomain: "tt.omtrdc.net"
        }
    }
}());

TNT._internal._helper = {};

(function(_module) {
    var _str = {}.toString;

    function _isUndefined(_value) {
        return _value === void(0);
    }

    function _isNull(_value) {
        return _value === null;
    }

    function _isEmpty(_value) {
        if (_isUndefined(_value) || _isNull(_value)) {
            return true;
        }

        return _value.length === 0;
    }

    function _isFunction(_value) {
        return _str.call(_value) === '[object Function]';
    }

    function _isArray(_value) {
        return _str.call(_value) === '[object Array]';
    }

    function _isString(_value) {
        return _str.call(_value) === '[object String]';
    }

    function _isObject(_value) {
        return _str.call(_value) === '[object Object]';
    }

    function _forEach(_arr, _fn) {
        var _len = _arr.length,
            _idx = -1;

        while (++_idx < _len) {
            _fn(_arr[_idx]);
        }
    }

    _module._isUndefined = _isUndefined;
    _module._isNull = _isNull;
    _module._isEmpty = _isEmpty;
    _module._isFunction = _isFunction;
    _module._isArray = _isArray;
    _module._isString = _isString;
    _module._isObject = _isObject;
    _module._forEach = _forEach;
}(TNT._internal._helper));


mboxUrlBuilder = function(_mboxServer, _clientCode) {
    this._mboxServer = _mboxServer;
    this._clientCode = _clientCode;
    this._parameters = [];
    this._urlProcess = function(_url) {
        return _url;
    };
    this._basePath = null;
};

mboxUrlBuilder.prototype = {
    constructor: mboxUrlBuilder,

    addNewParameter: function(_name, _value) {
        this._parameters.push({
            name: _name,
            value: _value
        });

        return this;
    },

    addParameterIfAbsent: function(_name, _value) {
        if (!_value) {
            return;
        }

        for (var _i = 0; _i < this._parameters.length; _i++) {
            var _parameter = this._parameters[_i];

            if (_parameter.name === _name) {
                return this;
            }
        }

        this.checkInvalidCharacters(_name);

        return this.addNewParameter(_name, _value);
    },

    addParameter: function(_name, _value) {
        this.checkInvalidCharacters(_name);

        for (var _i = 0; _i < this._parameters.length; _i++) {
            var _parameter = this._parameters[_i];

            if (_parameter.name === _name) {
                _parameter.value = _value;

                return this;
            }
        }

        return this.addNewParameter(_name, _value);
    },

    addParameters: function(_parameters) {
        if (!_parameters) {
            return this;
        }

        for (var _i = 0; _i < _parameters.length; _i++) {
            var _pair = _parameters[_i];
            var _splitIndex = _pair.indexOf('=');

            if (_splitIndex === -1 || _splitIndex === 0) {
                continue;
            }

            this.addParameter(_pair.substring(0, _splitIndex), _pair.substring(_splitIndex + 1, _pair.length));
        }

        return this;
    },

    setServerType: function(_type) {
        this._serverType = _type;
    },

    setBasePath: function(_basePath) {
        this._basePath = _basePath;
    },

    setUrlProcessAction: function(_action) {
        this._urlProcess = _action;
    },

    buildUrl: function() {
        var _server = TNT._internal._getMboxEdgeServer(this._mboxServer),
            _path = this._basePath ? this._basePath : '/m2/' + this._clientCode + '/mbox/' + this._serverType,
            _protocol = document.location.protocol == 'file:' ? 'http:' : document.location.protocol,
            _url = _protocol + "//" + _server + _path,
            _parts = [];

        for (var _i = 0; _i < this._parameters.length; _i++) {
            var _parameter = this._parameters[_i];

            _parts.push(encodeURIComponent(_parameter.name) + '=' + encodeURIComponent(_parameter.value));
        }

        _url += _url.indexOf('?') != -1 ? '&' + _parts.join('&') : '?' + _parts.join('&');

        return this._escapeQuote(this._urlProcess(_url));
    },

    getParameters: function() {
        return this._parameters;
    },

    setParameters: function(_parameters) {
        this._parameters = _parameters;
    },

    clone: function() {
        var _newUrlBuilder = new mboxUrlBuilder(this._mboxServer, this._clientCode);

        _newUrlBuilder.setServerType(this._serverType);
        _newUrlBuilder.setBasePath(this._basePath);
        _newUrlBuilder.setUrlProcessAction(this._urlProcess);

        for (var _i = 0; _i < this._parameters.length; _i++) {
            _newUrlBuilder.addParameter(this._parameters[_i].name, this._parameters[_i].value);
        }

        return _newUrlBuilder;
    },

    _escapeQuote: function(_text) {
        return _text.replace(/\"/g, '&quot;').replace(/>/g, '&gt;');
    },

    checkInvalidCharacters: function(_name) {
        var _invalidCharacters = new RegExp('(\'|")');

        if (_invalidCharacters.exec(_name)) {
            throw "Parameter '" + _name + "' contains invalid characters";
        }
    }
};

mboxStandardFetcher = function() {};

mboxStandardFetcher.prototype = {
    constructor: mboxStandardFetcher,

    getType: function() {
        return 'standard';
    },

    fetch: function(_urlBuilder) {
        _urlBuilder.setServerType(this.getType());

        document.write('<' + 'scr' + 'ipt src="' + _urlBuilder.buildUrl() + '"><' + '\/scr' + 'ipt>');
    },

    cancel: function() {}
};

mboxAjaxFetcher = function() {};

mboxAjaxFetcher.prototype = {
    constructor: mboxAjaxFetcher,

    getType: function() {
        return 'ajax';
    },

    fetch: function(_urlBuilder) {
        _urlBuilder.setServerType(this.getType());

        var _head = document.getElementsByTagName('head')[0],
            _include = document.createElement('script');

        _include.src = _urlBuilder.buildUrl();

        _head.appendChild(_include);
    },

    cancel: function() {}
};

(function(_module) {
    function _globalMboxFetcher() {}

    _globalMboxFetcher.prototype = {
        constructor: _globalMboxFetcher,

        getType: function() {
            return 'ajax';
        },

        fetch: function(_urlBuilder) {
            _urlBuilder.setServerType(this.getType());

            document.write('<' + 'scr' + 'ipt src="' + _urlBuilder.buildUrl() + '"><' + '\/scr' + 'ipt>');
        },

        cancel: function() {}
    };

    _module._globalMboxFetcher = _globalMboxFetcher;
}(TNT._internal));

mboxMap = function() {
    this._backingMap = {};
    this._keys = [];
};

mboxMap.prototype = {
    constructor: mboxMap,

    put: function(_key, _value) {
        if (!this._backingMap[_key]) {
            this._keys[this._keys.length] = _key;
        }

        this._backingMap[_key] = _value;
    },

    get: function(_key) {
        return this._backingMap[_key];
    },

    remove: function(_key) {
        var _updatedKeys = [];
        this._backingMap[_key] = undefined;


        for (var i = 0; i < this._keys.length; i++) {
            if (this._keys[i] !== _key) {
                _updatedKeys.push(this._keys[i]);
            }
        }

        this._keys = _updatedKeys;
    },

    each: function(_action) {
        for (var _i = 0; _i < this._keys.length; _i++) {
            var _key = this._keys[_i];
            var _value = this._backingMap[_key];

            if (_value) {
                var _result = _action(_key, _value);

                if (_result === false) {
                    break;
                }
            }
        }
    },

    isEmpty: function() {
        return this._keys.length === 0;
    }
};

mboxList = function() {
    this._mboxes = [];
};

mboxList.prototype = {
    constructor: mboxList,

    add: function(_mbox) {
        if (!_mbox) {
            return;
        }

        this._mboxes.push(_mbox);
    },

    get: function(_mboxName) {
        var _result = new mboxList();

        for (var _i = 0; _i < this._mboxes.length; _i++) {
            var _mbox = this._mboxes[_i];

            if (_mbox.getName() === _mboxName) {
                _result.add(_mbox);
            }
        }

        return _result;
    },

    getById: function(_index) {
        return this._mboxes[_index];
    },

    length: function() {
        return this._mboxes.length;
    },

    each: function(_action) {
        var _helper = TNT._internal._helper;

        if (!_helper._isFunction(_action)) {
            throw 'Action must be a function, was: ' + typeof(_action);
        }

        for (var _i = 0; _i < this._mboxes.length; _i++) {
            _action(this._mboxes[_i]);
        }
    }
};

mboxSignaler = function(_factory) {
    this._factory = _factory;
};

mboxSignaler.prototype = {
    constructor: mboxSignaler,

    signal: function(_signalType, _mboxName /*,...*/ ) {
        if (!this._factory.isEnabled()) {
            return;
        }

        var _body = mboxSignaler._getDocumentBody(),
            _divNode = this._createDivNode(this._factory._getMboxMarkerDivId(_mboxName));

        _body.appendChild(_divNode);

        var _args = [].slice.call(arguments, 1),
            _mbox = this._factory.create(_mboxName, _args, _divNode),
            _urlBuilder = _mbox.getUrlBuilder();

        _urlBuilder.addParameter(TNT._internal._params._page, mboxGenerateId());
        _mbox.setFetcher(new mboxAjaxFetcher());
        _mbox.load();
    },

    _createDivNode: function(_id) {
        var _result = document.createElement('div');

        _result.id = _id;
        _result.style.visibility = 'hidden';
        _result.style.display = 'none';

        return _result;
    }
};

mboxSignaler._getDocumentBody = function() {
    return document.body;
};

//
// Note this constructor also writes a node to the DOM, do not create
// after the page is loaded
//
mboxLocatorDefault = function(_divId) {
    this._divId = _divId;

    document.write('<div id="' + this._divId + '" style="visibility:hidden;display:none">&nbsp;<\/div>');
};

mboxLocatorDefault.prototype = {
    constructor: mboxLocatorDefault,

    locate: function() {
        var _ELEMENT_NODE = 1,
            _node = document.getElementById(this._divId);

        while (_node) {
            if (_node.nodeType === _ELEMENT_NODE && _node.className === 'mboxDefault') {
                return _node;
            }

            _node = _node.previousSibling;
        }

        return null;
    },

    force: function() {
        // There was no default div, add an empty one
        var _marker = document.getElementById(this._divId),
            _div = document.createElement('div');

        _div.className = 'mboxDefault';

        if (_marker) {
            _marker.parentNode.insertBefore(_div, _marker);
        }

        return _div;
    }
};

mboxLocatorNode = function(_node) {
    this._node = _node;
};

mboxLocatorNode.prototype = {
    constructor: mboxLocatorNode,

    locate: function() {
        return typeof(this._node) === 'string' ? document.getElementById(this._node) : this._node;
    },

    force: function() {
        return null;
    }
};

mboxOfferContent = function() {
    this._onLoad = function() {};
};

mboxOfferContent.prototype = {
    constructor: mboxOfferContent,

    show: function(_mbox) {
        var _result = _mbox.showContent(document.getElementById(_mbox.getImportName()));

        if (_result === 1) {
            this._onLoad();
        }

        return _result;
    },

    setOnLoad: function(_onLoad) {
        this._onLoad = _onLoad;
    }
};

mboxOfferAjax = function(_content) {
    this._content = _content;
    this._onLoad = function() {};
};

mboxOfferAjax.prototype = {
    constructor: mboxOfferAjax,

    setOnLoad: function(_onLoad) {
        this._onLoad = _onLoad;
    },

    show: function(_mbox) {
        var _contentDiv = document.createElement('div'),
            _result;

        _contentDiv.id = _mbox.getImportName();
        _contentDiv.innerHTML = this._content;

        _result = _mbox.showContent(_contentDiv);

        if (_result === 1) {
            this._onLoad();
        }

        return _result;
    }
};

mboxOfferDefault = function() {
    this._onLoad = function() {};
};

mboxOfferDefault.prototype = {
    constructor: mboxOfferDefault,

    show: function(_mbox) {
        var _result = _mbox.hide();

        if (_result === 1) {
            this._onLoad();
        }

        return _result;
    },

    setOnLoad: function(_onLoad) {
        this._onLoad = _onLoad;
    }
};

mboxCookieManager = function(_name, _domain) {
    this._name = _name;
    this._checkCookie = TNT._internal._cookies._check;
    this._crossDomainXOnly = TNT._internal._settings.crossDomainXOnly;
    this._disableCookie = TNT._internal._cookies._disable;
    this._usePersistentCookies = TNT._internal._settings.usePersistentCookies;
    this._cookiesMap = new mboxMap();

    // single word domains are not accepted in a cookie domain clause
    this._domain = _domain === '' || _domain.indexOf('.') === -1 ? '' : '; domain=' + _domain;

    this.loadCookies();
};

mboxCookieManager.prototype = {
    constructor: mboxCookieManager,

    isEnabled: function() {
        this.setCookie(this._checkCookie, 'true', 60);
        this.loadCookies();

        return this.getCookie(this._checkCookie) == 'true';
    },

    setCookie: function(_name, _value, _duration) {
        if (typeof _name == 'undefined' || typeof _value == 'undefined' || typeof _duration == 'undefined') {
            return;
        }

        var _expireOn = Math.ceil(_duration + new Date().getTime() / 1000),
            _cookie = mboxCookieManager._createCookie(_name, encodeURIComponent(_value), _expireOn);

        this._cookiesMap.put(_name, _cookie);
        this.saveCookies();
    },

    getCookie: function(_name) {
        var _cookie = this._cookiesMap.get(_name);

        return _cookie ? decodeURIComponent(_cookie.value) : null;
    },

    deleteCookie: function(_name) {
        this._cookiesMap.remove(_name);
        this.saveCookies();
    },

    getCookieNames: function(_namePrefix) {
        var _cookieNames = [];

        this._cookiesMap.each(function(_name, _cookie) {
            if (_name.indexOf(_namePrefix) === 0) {
                _cookieNames[_cookieNames.length] = _name;
            }
        });

        return _cookieNames;
    },

    saveCookies: function() {
        var _self = this,
            _cookieValues = [],
            _maxExpireOn = 0;

        this._cookiesMap.each(function(_name, _cookie) {
            if (!_self._crossDomainXOnly || _name === _self._disableCookie) {
                _cookieValues[_cookieValues.length] = mboxCookieManager._serializeCookie(_cookie);

                if (_maxExpireOn < _cookie.expireOn) {
                    _maxExpireOn = _cookie.expireOn;
                }
            }
        });

        var _expiration = new Date(_maxExpireOn * 1000);
        var _parts = [];

        _parts.push(this._name, '=', _cookieValues.join('|'));

        if (_self._usePersistentCookies) {
            _parts.push('; expires=', _expiration.toGMTString());
        }

        _parts.push('; path=/', this._domain);

        document.cookie = _parts.join("");
    },

    loadCookies: function() {
        var _masterCookie = mboxCookieManager._getMasterCookie(this._name),
            _internalCookies = mboxCookieManager._getInternalCookies(_masterCookie),
            _nowInSeconds = Math.ceil(new Date().getTime() / 1000);

        this._cookiesMap = new mboxMap();

        for (var _i = 0; _i < _internalCookies.length; _i++) {
            var _cookie = mboxCookieManager._deserializeCookie(_internalCookies[_i]);

            if (_nowInSeconds > _cookie.expireOn) {
                continue;
            }

            this._cookiesMap.put(_cookie.name, _cookie);
        }
    }
};

mboxCookieManager._serializeCookie = function(_cookie) {
    return _cookie.name + '#' + _cookie.value + '#' + _cookie.expireOn;
};

mboxCookieManager._deserializeCookie = function(_str) {
    var _parts = _str.split('#');

    return mboxCookieManager._createCookie(_parts[0], _parts[1], _parts[2]);
};

mboxCookieManager._createCookie = function(_name, _value, _expireOn) {
    return {
        name: _name,
        value: _value,
        expireOn: _expireOn
    };
};

mboxCookieManager._getMasterCookie = function(_name) {
    var result = new RegExp('(^|; )' + encodeURIComponent(_name) + '=([^;]*)').exec(document.cookie);

    return result ? result[2] : null;
};

mboxCookieManager._getInternalCookies = function(_str) {
    if (!_str) {
        return [];
    }

    return _str.split('|');
};

mboxSession = function(_randomId, _pageParamName, _cookieName, _expireTime, _cookieManager) {
    var _forcedSessionId = window.mboxForceSessionId;
    this._cookieName = _cookieName;
    this._expireTime = _expireTime;
    this._cookieManager = _cookieManager;
    this._id = typeof(_forcedSessionId) !== 'undefined' ? _forcedSessionId : mboxGetPageParameter(_pageParamName, true);
    this._id = this._id || _cookieManager.getCookie(_cookieName) || _randomId;

    this._cookieManager.setCookie(_cookieName, this._id, _expireTime);
};

mboxSession.prototype = {
    constructor: mboxSession,

    getId: function() {
        return this._id;
    },

    forceId: function(_forcedId) {
        this._id = _forcedId;

        this._cookieManager.setCookie(this._cookieName, this._id, this._expireTime);
    }
};

mboxPC = function(_cookieName, _expireTime, _cookieManager) {
    var _forcedPCId = window.mboxForcePCId;
    this._cookieName = _cookieName;
    this._expireTime = _expireTime;
    this._cookieManager = _cookieManager;
    this._id = typeof(_forcedPCId) != 'undefined' ? _forcedPCId : _cookieManager.getCookie(_cookieName);

    if (this._id) {
        _cookieManager.setCookie(_cookieName, this._id, _expireTime);
    }
};

mboxPC.prototype = {
    constructor: mboxPC,

    getId: function() {
        return this._id;
    },

    forceId: function(_forcedId) {
        if (this._id === _forcedId) {
            return false;
        }

        this._id = _forcedId;
        this._cookieManager.setCookie(this._cookieName, this._id, this._expireTime);

        return true;
    }
};

(function(_module, _helper, _cookies, _settings, _constants) {
    var _mboxEdgeExtractorRegex = new RegExp(".*\\.(\\d+)_\\d+");

    function _getMboxEdgeServer(_pcIdValue) {
        var _match = _mboxEdgeExtractorRegex.exec(_pcIdValue);

        if (_match && _match.length === 2) {
            return _constants._mboxEdgeServerPrefix + _match[1] + '.' + _constants._mboxClusterHostDomain;
        }

        return '';
    }

    function _saveMboxEdgeServerToCookieIfExists(_cookieManager, _pcId) {
        var _server = _getMboxEdgeServer(_pcId);

        if (!_helper._isEmpty(_server)) {
            _cookieManager.setCookie(_cookies._mboxEdgeServer, _server, _settings.overrideMboxEdgeServerTimeout);
        }
    }

    function _pcDecorator(_pc, _cookieManager) {
        this._pc = _pc;
        this._cookieManager = _cookieManager;

        _saveMboxEdgeServerToCookieIfExists(_cookieManager, _pc.getId());
    }

    _pcDecorator.prototype = {
        constructor: _pcDecorator,

        getId: function() {
            return this._pc.getId();
        },

        forceId: function(_forcedId) {
            if (!this._pc.forceId(_forcedId)) {
                return false;
            }

            _saveMboxEdgeServerToCookieIfExists(this._cookieManager, _forcedId);

            return true;
        }
    };

    _module._pcDecorator = _pcDecorator;
}(TNT._internal, TNT._internal._helper, TNT._internal._cookies, TNT._internal._settings, TNT._internal._constants));
mboxGetPageParameter = function(_name, _ignoreCase) {
    _ignoreCase = _ignoreCase || false;

    var _parameterRegExp;

    if (_ignoreCase) {
        _parameterRegExp = new RegExp("\\?[^#]*" + _name + "=([^\&;#]*)", "i");
    } else {
        _parameterRegExp = new RegExp("\\?[^#]*" + _name + "=([^\&;#]*)");
    }

    var _result = null;
    var _parameterMatch = _parameterRegExp.exec(document.location);

    if (_parameterMatch && _parameterMatch.length >= 2) {
        _result = _parameterMatch[1];
    }

    return _result;
};

mboxCookiePageDomain = function() {
    var _domain = (/([^:]*)(:[0-9]{0,5})?/).exec(document.location.host)[1];
    var _ipRegExp = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/;

    if (!_ipRegExp.exec(_domain)) {
        var _baseDomain = (/([^\.]+\.[^\.]{3}|[^\.]+\.[^\.]+\.[^\.]{2})$/).exec(_domain);

        if (_baseDomain) {
            _domain = _baseDomain[0];

            if (_domain.indexOf("www.") === 0) {
                _domain = _domain.substr(4);
            }
        }
    }

    return _domain ? _domain : "";
};

mboxShiftArray = function(_iterable) {
    var _result = [];

    for (var _i = 1; _i < _iterable.length; _i++) {
        _result[_result.length] = _iterable[_i];
    }

    return _result;
};

mboxGenerateId = function() {
    return (new Date()).getTime() + "-" + Math.floor(Math.random() * 999999);
};

mboxScreenHeight = function() {
    return screen.height;
};

mboxScreenWidth = function() {
    return screen.width;
};

mboxBrowserWidth = function() {
    return (window.innerWidth) ? window.innerWidth :
        document.documentElement ? document.documentElement.clientWidth :
        document.body.clientWidth;
};

mboxBrowserHeight = function() {
    return (window.innerHeight) ? window.innerHeight :
        document.documentElement ? document.documentElement.clientHeight :
        document.body.clientHeight;
};

mboxBrowserTimeOffset = function() {
    return -new Date().getTimezoneOffset();
};

mboxScreenColorDepth = function() {
    return screen.pixelDepth;
};

// This module represents a callback counter or
// more familiar to Java people a cyclic barrier

TNT._internal._join = (function() {
    var _waiting = [],
        _done = 0,
        _callbacks = [];

    function _partial(_index, _args) {
        _done += 1;
        _waiting[_index] = _args;

        _complete();
    }

    function _complete() {
        var _len = _callbacks.length,
            _idx = -1,
            _cb;

        if (_done !== _waiting.length || !_callbacks.length) {
            return;
        }

        while (++_idx < _len) {
            _cb = _callbacks[_idx];
            _cb.fn.apply(_cb.ctx, _waiting);
        }
    }

    return {
        _add: function() {
            var _index = _waiting.length;

            _waiting[_waiting.length] = null;

            return function() {
                _partial(_index, [].slice.call(arguments));
            };
        },

        _then: function(cb, context) {
            _callbacks.push({
                fn: cb,
                ctx: context
            });
            _complete();
        }
    };
}());

/**
 * Class that is the base of all mbox types.
 * @PrivateClass
 *
 * @param _name - name of mbox
 * @param _id - index of this mbox in the list of mboxes of the same name
 * @param _urlBuilder - used to build url of the request
 * @param _mboxLocator object must support
 *   DOMNode locate() which should return null until the DOMNode is found.
 *   DOMNode force() which as a last resort should attempt to create
 *                   a DOMNOde and return it or null
 * @param _importName id of the node containing offer content
 * @param _factory factory that tries to create this mbox
 */
mbox = function(_name, _id, _urlBuilder, _mboxLocator, _importName, _factory) {
    this._timeout = null;
    this._activated = 0;
    this._locator = _mboxLocator;
    this._importName = _importName;
    this._contentFetcher = null;

    this._offer = new mboxOfferContent();
    this._div = null;
    this._urlBuilder = _urlBuilder;

    // Information to support debugging
    this.message = '';
    this._times = {};
    this._activateCount = 0;
    this._maxActivateCount = 5;

    this._id = _id;
    this._name = _name;

    this._validateName();

    _urlBuilder.addParameter(TNT._internal._params._mboxName, _name);
    _urlBuilder.addParameter(TNT._internal._params._mboxId, _id);

    this._onError = function() {};
    this._onLoad = function() {};

    this._defaultDiv = null;
    // enabled for IE10+ only during page load
    this._waitForNestedMboxes = document.documentMode >= 10 && !_factory.isDomLoaded();

    if (this._waitForNestedMboxes) {
        this._nestedMboxes = TNT._internal.nestedMboxes;
        this._nestedMboxes.push(this._name);
    }
};

mbox.prototype.getId = function() {
    return this._id;
};

mbox.prototype._validateName = function() {
    var maxLength = TNT._internal._constants._mboxNameMaxLength;

    if (this._name.length > maxLength) {
        throw "Mbox Name " + this._name + " exceeds max length of " + maxLength + " characters.";
    } else if (this._name.match(/^\s+|\s+$/g)) {
        throw "Mbox Name " + this._name + " has leading/trailing whitespace(s).";
    }
};

mbox.prototype.getName = function() {
    return this._name;
};

/**
 * @return Array an array of parameters
 */
mbox.prototype.getParameters = function() {
    var _parameters = this._urlBuilder.getParameters();
    var _result = [];

    for (var _i = 0; _i < _parameters.length; _i++) {
        // do not include internal parameters
        if (_parameters[_i].name.indexOf('mbox') !== 0) {
            _result[_result.length] = _parameters[_i].name + '=' + _parameters[_i].value;
        }
    }

    return _result;
};

/**
 * Sets the action to execute when the offer has loaded.
 * To be used with mboxUpdate.
 */
mbox.prototype.setOnLoad = function(_action) {
    this._onLoad = _action;
    return this;
};

mbox.prototype.setMessage = function(_message) {
    this.message = _message;
    return this;
};

/**
 * @param _onError is a function that takes two string arguments:
 *   message, fetch type
 */
mbox.prototype.setOnError = function(_onError) {
    this._onError = _onError;
    return this;
};

mbox.prototype.setFetcher = function(_fetcher) {
    if (this._contentFetcher) {
        this._contentFetcher.cancel();
    }
    this._contentFetcher = _fetcher;
    return this;
};

mbox.prototype.getFetcher = function() {
    return this._contentFetcher;
};

/**
 * Loads mbox content.
 * @param _parameters - Optional parameters to be added to the request.
 */
mbox.prototype.load = function(_parameters) {
    var _urlBuilder = this._urlBuilder;

    if (this._contentFetcher === null) {
        return this;
    }

    this.setEventTime("load.start");
    this.cancelTimeout();
    this._activated = 0;

    if (_parameters && _parameters.length > 0) {
        _urlBuilder = this._urlBuilder.clone().addParameters(_parameters);
    }

    this._contentFetcher.fetch(_urlBuilder);

    var _self = this;
    this._timer = setTimeout(function() {
        _self._onError('browser timeout', _self._contentFetcher.getType());
    }, TNT._internal._settings.mboxTimeout);

    this.setEventTime("load.end");

    /*WDPRO Additions*/
    /*hide targets initially when specified*/
    if (!!tnt_wdpro.aMboxTargets) {
        tnt_wdpro.pollTargetElement(this.getName(), tnt_wdpro.hideMboxTargetDivs);
    }
    /*End WDPRO Additions*/

    return this;
};

/*
 * Used by the server to signal that all assets have been loaded by
 * the browser.
 */
mbox.prototype.loaded = function() {
    this.cancelTimeout();

    // To avoid a runaway timer, we will try to activate ONLY a specific number of times
    if (!this.activate() && this._activateCount < this._maxActivateCount) {
        var _self = this;

        setTimeout(function() {
            _self.loaded();
        }, TNT._internal._settings.mboxLoadedTimeout);
    }

    /* WDPRO Additions */
    // Put returned content div into global hasmap
    var mboxName = this.getName();
    if (!!tnt_wdpro.aMboxTargets && tnt_wdpro.aMboxTargets[mboxName] !== '') {
        tnt_wdpro.aMboxes[mboxName] = this.getDiv();
        tnt_wdpro.pollTargetElement(mboxName, tnt_wdpro.moveContent);
    }
};

/**
 * Called when the mbox has been successfully loaded to activate
 * the mbox for display.
 *
 * This call may fail if the DOM has not been fully constructed
 */
mbox.prototype.activate = function() {
    /** WDPRO Additions **/
    // if (this._activated) {
    //     return this._activated;
    // }
    /** End WDPRO Additions **/
    this.setEventTime('activate' + (++this._activateCount) + '.start');

    if (this._waitForNestedMboxes && this._nestedMboxes[this._nestedMboxes.length - 1] !== this._name) {
        return this._activated;
    }

    if (this.show()) {
        this.cancelTimeout();
        this._activated = 1;
    }
    this.setEventTime('activate' + this._activateCount + '.end');

    if (this._waitForNestedMboxes) {
        this._nestedMboxes.pop();
    }
    return this._activated;
};

/**
 * @return true if the mbox has been successfully activated
 */
mbox.prototype.isActivated = function() {
    return this._activated;
};

/**
 * Sets an offer into mbox.
 *
 * @param _offer Offer object that must have 'show(mbox)' method which
 * will be called to render this offer within the mbox passed in.
 *
 * The offer.show() method should return 1 on success and 0 on error.
 */
mbox.prototype.setOffer = function(_offer) {
    var _offerExists = _offer && _offer.show && _offer.setOnLoad;

    if (!_offerExists) {
        throw 'Invalid offer';
    }

    var _shouldCopyOnLoad = TNT._internal._settings.globalMboxName === this._name;
    _shouldCopyOnLoad = _shouldCopyOnLoad && _offer instanceof mboxOfferDefault;
    _shouldCopyOnLoad = _shouldCopyOnLoad && this._contentFetcher !== null;
    _shouldCopyOnLoad = _shouldCopyOnLoad && this._contentFetcher.getType() === 'ajax';

    if (!_shouldCopyOnLoad) {
        this._offer = _offer;

        return this;
    }

    // The _onLoad will be copied ONLY when we have global mbox,
    // the content fetcher is of type AJAX
    // and the offer to be set is of type mboxDefaultOffer
    // in all other cases we will use the normal flow
    var _onLoadFunc = this._offer._onLoad;
    this._offer = _offer;

    this._offer.setOnLoad(_onLoadFunc);

    return this;
};

mbox.prototype.getOffer = function() {
    return this._offer;
};

/**
 * Shows the offer.
 *
 * @return 1 if it was possible to show the content, 0 otherwise.
 */
mbox.prototype.show = function() {
    /* WDPRO Additions */
    var target;
    /* End WDPRO Additions */

    this.setEventTime('show.start');
    var _result = this._offer.show(this);
    this.setEventTime(_result == 1 ? "show.end.ok" : "show.end");

    /* WDPRO Additions */
    // if callback function exists then call it
    if ('function' == typeof mbox.mboxShowCallback) {
        mbox.mboxShowCallback(_result);
    }

    //if there was a TnT failure, make sure the target div is reshown
    if (_result !== 1) {
        var mboxName = this.getName();
        if (!!tnt_wdpro.aMboxTargets[mboxName] && tnt_wdpro.aMboxTargets[mboxName] !== '') {
            target = tnt_wdpro.getElement(tnt_wdpro.aMboxTargets[mboxName]);
            tnt_wdpro.showMboxTargetDivs(mboxName, target);
        }
    }
    /* End WDPRO Additions */

    return _result;
};

/**
 * Shows the specified content in the mbox.
 *
 * @return Number 1 if it was possible to show the content, 0 otherwise.
 */
mbox.prototype.showContent = function(_content) {
    if (!mbox._isContentAvailable(_content)) {
        return 0;
    }

    this._div = mbox._getMarkerDivIfRequired(this, this._div);

    if (this._div === null) {
        return 0;
    }

    if (!mbox._containsNode(document.body, this._div)) {
        return 0;
    }

    if (this._div === _content) {
        this._showDiv(this._div);
        this._onLoad();
        return 1;
    }

    this._hideDiv(this._div);
    this._hideDiv(_content);

    mbox._replaceDiv(this, _content);

    this._showDiv(this._div);
    this._onLoad();

    return 1;
};

mbox._isContentAvailable = function(_content) {
    return _content !== undefined && _content !== null;
};

mbox._containsNode = function(_parent, _child) {
    var DOCUMENT_POSITION_CONTAINED_BY = 16;
    var _containsMethodExists = _parent.contains !== undefined;

    // Node.contains() is available in IE and some versions of Safari
    // some versions of FireFox do not have support for Node.contains()
    if (_containsMethodExists) {
        return _parent !== _child && _parent.contains(_child);
    } else {
        // w3c DOM Level 3 should be available in all modern browsers
        return Boolean(_parent.compareDocumentPosition(_child) & DOCUMENT_POSITION_CONTAINED_BY);
    }
};

mbox._getMarkerDivIfRequired = function(_mbox, _div) {
    if (_div !== undefined && _div !== null && mbox._containsNode(document.body, _div)) {
        return _div;
    }

    return _mbox.getDefaultDiv();
};

mbox._replaceDiv = function(_mbox, _newDiv) {
    _mbox._div.parentNode.replaceChild(_newDiv, _mbox._div);
    _mbox._div = _newDiv;
};

/**
 * Hides any fetched content and show Default Content associated
 * with the mbox if it is avaliable yet.
 *
 * @return 1 if it was possible to show the default content
 */
mbox.prototype.hide = function() {
    this.setEventTime('hide.start');
    var _result = this.showContent(this.getDefaultDiv());
    this.setEventTime(_result == 1 ? 'hide.end.ok' : 'hide.end.fail');
    return _result;
};

/**
 * Puts the mbox into a shown state, if that fails shows default content
 * Also cancels any timeouts associated with the mbox
 */
mbox.prototype.finalize = function() {
    this.setEventTime('finalize.start');
    this.cancelTimeout();

    if (!this.getDefaultDiv()) {
        if (this._locator.force()) {
            this.setMessage('No default content, an empty one has been added');
        } else {
            this.setMessage('Unable to locate mbox');
        }
    }

    if (!this.activate()) {
        this.hide();
        this.setEventTime('finalize.end.hide');
    }
    this.setEventTime('finalize.end.ok');
};

mbox.prototype.cancelTimeout = function() {
    if (this._timer) {
        clearTimeout(this._timer);
    }
    if (this._contentFetcher) {
        this._contentFetcher.cancel();
    }
};

mbox.prototype.getDiv = function() {
    return this._div;
};

/**
 * returns valid default div
 * (even if it's not present in the DOM anymore)
 */
mbox.prototype.getDefaultDiv = function() {
    if (this._defaultDiv === null) {
        this._defaultDiv = this._locator.locate();
    }
    return this._defaultDiv;
};

mbox.prototype.setEventTime = function(_event) {
    this._times[_event] = (new Date()).getTime();
};

mbox.prototype.getEventTimes = function() {
    return this._times;
};

mbox.prototype.getImportName = function() {
    return this._importName;
};

mbox.prototype.getURL = function() {
    return this._urlBuilder.buildUrl();
};

mbox.prototype.getUrlBuilder = function() {
    return this._urlBuilder;
};

mbox.prototype._isVisible = function(_div) {
    return _div.style.display != 'none';
};

mbox.prototype._showDiv = function(_div) {
    this._toggleDiv(_div, true);
};

mbox.prototype._hideDiv = function(_div) {
    this._toggleDiv(_div, false);
};

mbox.prototype._toggleDiv = function(_div, _visible) {
    _div.style.visibility = _visible ? "visible" : "hidden";
    _div.style.display = _visible ? "block" : "none";
};

mbox.prototype._disableWaitForNestedMboxes = function() {
    this._waitForNestedMboxes = false;
};

mbox.prototype.relocateDefaultDiv = function() {
    this._defaultDiv = this._locator.locate();
};

/**
 * Creates and updates mboxes.
 *
 * @param _server host of the mbox server e.g.mbox-test.dev.tt.omtrdc.net
 * @param _clientCode - client's code e.g. 'demo'
 * @param _factoryId - a unique string identifying this factory
 */
mboxFactory = function(_server, _clientCode, _factoryId) {
    var _context = TNT._internal;
    var _settings = _context._settings;
    var _cookies = _context._cookies;
    var _pageParams = _context._pageParams;
    var _constants = _context._constants;
    var _version = _settings.mboxVersion;

    this._pageLoaded = false;
    this._factoryId = _factoryId;
    this._mboxes = new mboxList();

    mboxFactories.put(_factoryId, this);

    // mboxIsSupported is a client defined function to test if mbox is supported
    // on this platform (defaults to just returning true)
    this._supported = _settings.mboxIsSupportedFunction() &&
        typeof(window.attachEvent || document.addEventListener || window.addEventListener) != 'undefined';

    this._enabled = this._supported && mboxGetPageParameter(_pageParams._disable, true) === null;

    var _isDefaultFactory = _factoryId == _constants._defaultFactoryId;
    var _cookieName = _constants._cookieNamePrefix + (_isDefaultFactory ? '' : ('-' + _factoryId));
    this._cookieManager = new mboxCookieManager(_cookieName, _settings.cookieDomainFunction());

    if (!_settings.crossDomainXOnly) {
        this._enabled = this._enabled && this._cookieManager.isEnabled();
    }

    this._enabled = this._enabled &&
        TNT._internal._helper._isNull(this._cookieManager.getCookie(_cookies._disable)) &&
        TNT._internal._helper._isNull(this._cookieManager.getCookie(_cookies._experienceManagerDisabled));

    if (this.isAdmin()) {
        this.enable();
    }

    this._listenForDomReady();
    this._mboxPageId = mboxGenerateId();
    this._mboxScreenHeight = mboxScreenHeight();
    this._mboxScreenWidth = mboxScreenWidth();
    this._mboxBrowserWidth = mboxBrowserWidth();
    this._mboxBrowserHeight = mboxBrowserHeight();
    this._mboxColorDepth = mboxScreenColorDepth();
    this._mboxBrowserTimeOffset = mboxBrowserTimeOffset();
    this._mboxSessionId = new mboxSession(this._mboxPageId, _pageParams._sessionId, _cookies._sessionId,
        _settings.sessionExpirationTimeout, this._cookieManager);

    var _pc = new mboxPC(_cookies._tntId, _settings.tntIdLifetime, this._cookieManager);

    this._mboxPCId = _settings.overrideMboxEdgeServer ? new _context._pcDecorator(_pc, this._cookieManager) : _pc;
    this._urlBuilder = new mboxUrlBuilder(_server, _clientCode);

    this._initGlobalParameters(this._urlBuilder, _isDefaultFactory, _version);

    this._pageStartTime = new Date().getTime();
    this._pageEndTime = this._pageStartTime;

    var _self = this;
    this.addOnLoad(function() {
        _self._pageEndTime = new Date().getTime();
    });

    if (this._supported) {
        // Checks that all mboxes have been successfully imported
        // and shows default content for any that failed
        this.addOnLoad(function() {
            _self._pageLoaded = true;
            _self.getMboxes().each(function(_mbox) {
                _mbox._disableWaitForNestedMboxes();
                _mbox.setFetcher(new mboxAjaxFetcher());
                _mbox.finalize();
            });
            TNT._internal.nestedMboxes = [];
        });

        if (this._enabled) {
            this.limitTraffic(_settings.trafficLevelPercentage, _settings.trafficDuration);

            this._makeDefaultContentInvisible();

            this._mboxSignaler = new mboxSignaler(this);
        } else {
            if (!_settings.isProduction) {
                if (this.isAdmin()) {
                    if (!this.isEnabled()) {
                        alert("mbox disabled, probably due to timeout\n" +
                            "Reset your cookies to re-enable\n(this message will only appear in administrative mode)");
                    } else {
                        alert("It looks like your browser will not allow " +
                            _settings.companyName +
                            " to set its administrative cookie. To allow setting the" +
                            " cookie please lower the privacy settings of your browser.\n" +
                            "(this message will only appear in administrative mode)");
                    }
                }
            }
        }
    }
};

/**
 * Forcibly sets new PC ID.
 * This method should be used when there is a better way to track
 * a site user than by PC ID.
 *
 * @param _forcedId New PC ID to set.
 */
mboxFactory.prototype.forcePCId = function(_forcedId) {
    if (!TNT._internal._settings.clientTntIdSupport) {
        return;
    }

    if (this._mboxPCId.forceId(_forcedId)) {
        this._mboxSessionId.forceId(mboxGenerateId());
    }
};

/**
 * Allows the client to use their sessionId as the mbox sessionId. This
 * is useful if the client is required to preserve their id through their
 * site.
 *
 * @param sessionId for New session id.
 */
mboxFactory.prototype.forceSessionId = function(_forcedId) {
    if (!TNT._internal._settings.clientSessionIdSupport) {
        return;
    }

    this._mboxSessionId.forceId(_forcedId);
};

/**
 * @return true if the factory is enabled. If factory is disabled, the mboxes
 * are still created but they show default content only.
 */
mboxFactory.prototype.isEnabled = function() {
    return this._enabled;
};

/**
 * @return cause of mbox disabling
 */
mboxFactory.prototype.getDisableReason = function() {
    return this._cookieManager.getCookie(TNT._internal._cookies._disable);
};

/**
 * @return true if the client's environment is supported (i.e. there's a way
 *   to access DOM elements via document.getElementById and event handling
 *   is supported)
 */
mboxFactory.prototype.isSupported = function() {
    return this._supported;
};

/**
 * Disables the factory for the specified duration.
 *
 * @param _duration - duration in seconds (optional)
 * @param _cause - cause of disable (optional)
 */
mboxFactory.prototype.disable = function(_duration, _cause) {
    if (typeof _duration == 'undefined') {
        _duration = 60 * 60;
    }

    if (typeof _cause == 'undefined') {
        _cause = 'unspecified';
    }

    if (!this.isAdmin()) {
        this._enabled = false;
        this._cookieManager.setCookie(TNT._internal._cookies._disable, _cause, _duration);
    }
};

mboxFactory.prototype.enable = function() {
    this._enabled = true;
    this._cookieManager.deleteCookie(TNT._internal._cookies._disable);
};

mboxFactory.prototype.isAdmin = function() {
    return document.location.href.indexOf(TNT._internal._pageParams._environment) != -1;
};

/**
 * Limits the traffic (by disabling the factory for certain users) to the given
 * level for the specified duration.
 */
mboxFactory.prototype.limitTraffic = function(_level, _duration) {
    if (TNT._internal._settings.trafficLevelPercentage != 100) {
        if (_level == 100) {
            return;
        }

        var _enable = true;

        if (parseInt(this._cookieManager.getCookie(TNT._internal._cookies._trafficLevel)) != _level) {
            _enable = (Math.random() * 100) <= _level;
        }

        this._cookieManager.setCookie(TNT._internal._cookies._trafficLevel, _level, _duration);

        if (!_enable) {
            this.disable(60 * 60, 'limited by traffic');
        }
    }
};

/**
 * Adds a function to be called with body onload.
 */
mboxFactory.prototype.addOnLoad = function(_function) {

    // This extra checking is so that if there is a race, where addOnLoad
    // is called as the onload functions are being called, we'll detect this
    // and correctly call the passed in function exactly once, after the dom
    // has loaded.

    if (this.isDomLoaded()) {
        _function();
    } else {
        var _calledFunction = false;
        var _wrapper = function() {
            if (_calledFunction) {
                return;
            }
            _calledFunction = true;
            _function();
        };

        this._onloadFunctions.push(_wrapper);

        if (this.isDomLoaded() && !_calledFunction) {
            _wrapper();
        }
    }
};

mboxFactory.prototype.getEllapsedTime = function() {
    return this._pageEndTime - this._pageStartTime;
};

mboxFactory.prototype.getEllapsedTimeUntil = function(_time) {
    return _time - this._pageStartTime;
};

/**
 * @return An mboxList object that contains the mboxes associated with this
 *   factory.
 */
mboxFactory.prototype.getMboxes = function() {
    return this._mboxes;
};

/**
 * @param _mboxId the id of the mbox, defaults to 0 if not specified.
 *
 * @return mbox with the specified _mboxName and _mboxId.
 */
mboxFactory.prototype.get = function(_mboxName, _mboxId) {
    return this._mboxes.get(_mboxName).getById(_mboxId || 0);
};

/**
 * Updates one or more mboxes with the name _mboxName
 *
 * @param _mboxName - name of the mbox
 * @param _parameters - array of 0 or more items of the form "name=value"
 *   (the values need to be escaped for inclusion in the url)
 */
mboxFactory.prototype.update = function(_mboxName, _parameters) {
    var _context = TNT._internal,
        _params = _context._params;

    if (!this.isEnabled()) {
        return;
    }

    var _self = this;

    if (!this.isDomLoaded()) {
        this.addOnLoad(function() {
            _self.update(_mboxName, _parameters);
        });

        return;
    }

    if (this._mboxes.get(_mboxName).length() === 0) {
        throw "Mbox " + _mboxName + " is not defined";
    }

    this._mboxes.get(_mboxName).each(function(_mbox) {
        var _urlBuilder = _mbox.getUrlBuilder();

        _urlBuilder.addParameter(_params._page, mboxGenerateId());
        _self._addSupplementalDataIfExists(_urlBuilder, _mboxName);
        _self._addTntIdIfExists(_urlBuilder);
        _self._addTargetPageParamsIfRequired(_urlBuilder, _mboxName);
        _mbox.load(_parameters);
    });
};

/**
 * This is a dummy method that we'll have to remove, all the logic is now part of Visitor API plugin
 */
mboxFactory.prototype.setVisitorIdParameters = function(_urlBuilder, _mboxName) {
    this._addSupplementalDataIfExists(_urlBuilder, _mboxName);
};

/**
 * Creates an mbox called _mboxName.
 *
 * There is a small chance that an mbox with the same name is created after
 * we call update - we will ignore this chance.
 *
 * @param _mboxName - name of the mbox
 * @param _parameters - array of 0 or more items of the form "name=value"
 *   (the values need to be escaped for inclusion in the url)
 * @param _defaultNode - the DOM node that is the default content
 *                       the name of the DOM that is the default content
 *                       or is not specified, search bacwords for
 *                       mboxDefault class to use as default content
 */
mboxFactory.prototype.create = function(_mboxName, _parameters, _defaultNode) {
    var _mbox = this._createMbox(_mboxName, _parameters, _defaultNode);

    if (_mbox) {
        this._addSupplementalDataIfExists(_mbox.getUrlBuilder(), _mboxName);
    }

    return _mbox;
};

/**
 * This method will be used ONLY in mboxDefine()
 *
 * @param _mboxName
 * @param _parameters
 * @param _defaultNode
 * @private
 */
mboxFactory.prototype._define = function(_mboxName, _parameters, _defaultNode) {
    return this._createMbox(_mboxName, _parameters, _defaultNode);
};

mboxFactory.prototype._createMbox = function(_mboxName, _parameters, _defaultNode) {
    if (!this.isSupported()) {
        return null;
    }

    var _now = new Date();
    var _time = _now.getTime() - (_now.getTimezoneOffset() * TNT._internal._constants._millisInMinute);
    var _urlBuilder = this._urlBuilder.clone();

    _urlBuilder.addParameter(TNT._internal._params._count, this._mboxes.length() + 1);
    _urlBuilder.addParameter(TNT._internal._params._time, _time);
    _urlBuilder.addParameters(_parameters);

    this._addTntIdIfExists(_urlBuilder);
    this._addTargetPageParamsIfRequired(_urlBuilder, _mboxName);

    var _mboxId, _locator, _mbox;

    if (_defaultNode) {
        _locator = new mboxLocatorNode(_defaultNode);
    } else {
        if (this._pageLoaded) {
            throw 'The page has already been loaded, can\'t write marker';
        }

        _locator = new mboxLocatorDefault(this._getMboxMarkerDivId(_mboxName));
    }

    try {
        _mboxId = this._mboxes.get(_mboxName).length();
        _mbox = new mbox(_mboxName, _mboxId, _urlBuilder, _locator, this._getMboxImportDivId(_mboxName), this);

        if (this._enabled) {
            _mbox.setFetcher(this._pageLoaded ? new mboxAjaxFetcher() : new mboxStandardFetcher());
        }

        var _self = this;

        _mbox.setOnError(function(_message, _type) {
            _mbox.setMessage(_message);
            _mbox.activate();

            if (!_mbox.isActivated()) {
                _self.disable(TNT._internal._settings.mboxFactoryDisabledTimeout, _message);
                window.location.reload(false);
            }
        });

        this._mboxes.add(_mbox);
    } catch (_e) {
        this.disable();
        throw 'Failed creating mbox "' + _mboxName + '", the error was: ' + _e;
    }

    return _mbox;
};

mboxFactory.prototype._addTntIdIfExists = function(_urlBuilder) {
    var _tntId = this._mboxPCId.getId();

    if (_tntId) {
        _urlBuilder.addParameter(TNT._internal._params._tntId, _tntId);
    }
};

mboxFactory.prototype._addSupplementalDataIfExists = function(_urlBuilder, _mboxName) {
    var _context = TNT._internal,
        _imsOrgId = _context._settings.imsOrgId,
        _clientCode = _context._settings.clientCode,
        _supplementalDataIdParam = _context._params._supplementalDataId,
        _supplementalDataId = _context._generateSupplementalDataId(_imsOrgId, _clientCode, _mboxName);

    // According to Visitor API folks we have to regenerate supplemental data ID
    // when mboxUpdate is invoked

    if (_supplementalDataId) {
        _urlBuilder.addParameter(_supplementalDataIdParam, _supplementalDataId);
    }
};

mboxFactory.prototype._addTargetPageParamsIfRequired = function(_urlBuilder, _mboxName) {
    var _shouldAddParams = !TNT.isAutoCreateGlobalMbox() && TNT.getGlobalMboxName() === _mboxName;

    if (_shouldAddParams) {
        _urlBuilder.addParameters(TNT.getTargetPageParameters());
    }
};

mboxFactory.prototype.getCookieManager = function() {
    return this._cookieManager;
};

mboxFactory.prototype.getPageId = function() {
    return this._mboxPageId;
};

mboxFactory.prototype.getPCId = function() {
    return this._mboxPCId;
};

mboxFactory.prototype.getSessionId = function() {
    return this._mboxSessionId;
};

mboxFactory.prototype.getSignaler = function() {
    return this._mboxSignaler;
};

mboxFactory.prototype.getUrlBuilder = function() {
    return this._urlBuilder;
};

mboxFactory.prototype._getMboxDivSuffix = function(_mboxName) {
    return this._factoryId + '-' + _mboxName + '-' + this._mboxes.get(_mboxName).length();
};

mboxFactory.prototype._getMboxMarkerDivId = function(_mboxName) {
    return TNT._internal._constants._divMarkerPrefix + this._getMboxDivSuffix(_mboxName);
};

mboxFactory.prototype._getMboxImportDivId = function(_mboxName) {
    return TNT._internal._constants._divImportPrefix + this._getMboxDivSuffix(_mboxName);
};

mboxFactory.prototype._initGlobalParameters = function(_urlBuilder, _isDefaultFactory, _version) {
    _urlBuilder.addParameter(TNT._internal._params._host, document.location.hostname);
    _urlBuilder.addParameter(TNT._internal._params._page, this._mboxPageId);
    _urlBuilder.addParameter(TNT._internal._params._screenHeight, this._mboxScreenHeight);
    _urlBuilder.addParameter(TNT._internal._params._screenWidth, this._mboxScreenWidth);
    _urlBuilder.addParameter(TNT._internal._params._browserWidth, this._mboxBrowserWidth);
    _urlBuilder.addParameter(TNT._internal._params._browserHeight, this._mboxBrowserHeight);
    _urlBuilder.addParameter(TNT._internal._params._browserTimeOffset, this._mboxBrowserTimeOffset);
    _urlBuilder.addParameter(TNT._internal._params._screenColorDepth, this._mboxColorDepth);
    _urlBuilder.addParameter(TNT._internal._pageParams._sessionId, this._mboxSessionId.getId());

    if (!_isDefaultFactory) {
        _urlBuilder.addParameter(TNT._internal._params._mboxFactoryId, this._factoryId);
    }

    this._addTntIdIfExists(_urlBuilder);

    if (TNT._internal._settings.crossDomainEnabled) {
        _urlBuilder.addParameter(TNT._internal._params._crossDomain, TNT._internal._settings.crossDomain);
    }

    var _params = TNT.getClientMboxExtraParameters();

    if (_params) {
        _urlBuilder.addParameters(_params.split('&'));
    }

    _urlBuilder.setUrlProcessAction(function(_url) {
        if (TNT._internal._settings.passPageParameters) {
            _url += '&';
            _url += TNT._internal._params._url;
            _url += '=' + encodeURIComponent(document.location);

            var _referrer = encodeURIComponent(document.referrer);

            if (_url.length + _referrer.length < 2000) {
                _url += '&';
                _url += TNT._internal._params._referrer;
                _url += '=' + _referrer;
            }
        }

        _url += '&';
        _url += TNT._internal._params._mboxVersion;
        _url += '=' + _version;

        return _url;
    });
};

/**
 * Causes all mbox default content to not be displayed:
 */
mboxFactory.prototype._makeDefaultContentInvisible = function() {
    document.write('<style>.' + TNT._internal._constants._divDefaultClass + ' { visibility:hidden; }</style>');
};

mboxFactory.prototype.isDomLoaded = function() {
    return this._pageLoaded;
};

mboxFactory.prototype._listenForDomReady = function() {
    if (this._onloadFunctions) {
        return;
    }

    this._onloadFunctions = [];

    var _self = this;
    (function() {
        var _eventName = document.addEventListener ? "DOMContentLoaded" : "onreadystatechange";
        var _loaded = false;
        var _ready = function() {
            if (_loaded) {
                return;
            }
            _loaded = true;
            for (var i = 0; i < _self._onloadFunctions.length; ++i) {
                _self._onloadFunctions[i]();
            }
        };

        if (document.addEventListener) {
            document.addEventListener(_eventName, function() {
                document.removeEventListener(_eventName, arguments.callee, false);
                _ready();
            }, false);

            window.addEventListener("load", function() {
                document.removeEventListener("load", arguments.callee, false);
                _ready();
            }, false);

        } else if (document.attachEvent) {
            if (self !== self.top) {
                document.attachEvent(_eventName, function() {
                    if (document.readyState === 'complete') {
                        document.detachEvent(_eventName, arguments.callee);
                        _ready();
                    }
                });
            } else {
                var _checkScrollable = function() {
                    try {
                        document.documentElement.doScroll('left');
                        _ready();
                    } catch (_domNotReady) {
                        setTimeout(_checkScrollable, 13);
                    }
                };
                _checkScrollable();
            }
        }

        if (document.readyState === "complete") {
            _ready();
        }

    })();
};

mboxScPluginFetcher = function(_clientCode, _siteCatalystCore) {
    this._clientCode = _clientCode;
    this._siteCatalystCore = _siteCatalystCore;
};

mboxScPluginFetcher.prototype = {
    constructor: mboxScPluginFetcher,

    getType: function() {
        return 'ajax';
    },

    fetch: function(_urlBuilder) {
        _urlBuilder.setServerType(this.getType());

        var _head = document.getElementsByTagName('head')[0],
            _include = document.createElement('script');

        _include.src = this._buildUrl(_urlBuilder);

        _head.appendChild(_include);
    },

    cancel: function() {},

    _buildUrl: function(_urlBuilder) {
        _urlBuilder.setBasePath('/m2/' + this._clientCode + '/sc/standard');
        this._addParameters(_urlBuilder);

        var _versionParam = TNT._internal._params._siteCatalystPluginVersion;
        var _versionValue = TNT._internal._constants._siteCatalystPluginVersion;

        _urlBuilder.addParameter(_versionParam, _versionValue);

        return _urlBuilder.buildUrl();
    },

    _addParameters: function(_urlBuilder) {
        var _parametersToRead = [
            "dynamicVariablePrefix", "visitorID", "vmk", "ppu", "charSet",
            "visitorNamespace", "cookieDomainPeriods", "cookieLifetime", "pageName",
            "currencyCode", "variableProvider", "channel", "server",
            "pageType", "transactionID", "purchaseID", "campaign", "state", "zip", "events",
            "products", "linkName", "linkType", "resolution", "colorDepth",
            "javascriptVersion", "javaEnabled", "cookiesEnabled", "browserWidth",
            "browserHeight", "connectionType", "homepage", "pe", "pev1", "pev2", "pev3",
            "visitorSampling", "visitorSamplingGroup", "dynamicAccountSelection",
            "dynamicAccountList", "dynamicAccountMatch", "trackDownloadLinks",
            "trackExternalLinks", "trackInlineStats", "linkLeaveQueryString",
            "linkDownloadFileTypes", "linkExternalFilters", "linkInternalFilters",
            "linkTrackVars", "linkTrackEvents", "linkNames", "lnk", "eo"
        ];

        for (var _i = 0; _i < _parametersToRead.length; _i++) {
            this._addParameterFromCore(_parametersToRead[_i], _urlBuilder);
        }

        for (_i = 1; _i <= 75; _i++) {
            this._addParameterFromCore('prop' + _i, _urlBuilder);
            this._addParameterFromCore('eVar' + _i, _urlBuilder);
            this._addParameterFromCore('hier' + _i, _urlBuilder);
        }
    },

    _addParameterFromCore: function(_name, _urlBuilder) {
        var _helper = TNT._internal._helper,
            _value = this._siteCatalystCore[_name];

        if (_helper._isEmpty(_value) || _helper._isObject(_value)) {
            return;
        }

        _urlBuilder.addParameter(_name, _value);
    }
};

(function(_module) {
    /**
     * This function returns the plugin, or null if it was not loaded.
     */
    function _mboxLoadSCPlugin(_factory, _siteCatalystCore) {
        if (!_siteCatalystCore) {
            return null;
        }

        var _pluginName = TNT._internal._settings.siteCatalystPluginName,
            _clientCode = TNT._internal._settings.clientCode,
            _helper = TNT._internal._helper;

        _siteCatalystCore["m_" + _pluginName] = function(_siteCatalystCore) {
            var _specialFuncName = '_t',
                _pluginFuncName = 'm_i',
                _plugin = _siteCatalystCore[_pluginFuncName](_pluginName);

            _plugin._enabled = true;
            _plugin._clientCode = _clientCode;

            /** This method is called by the core when it's ready to make a request.
             * it cannot be obfuscated, since _t is a special name.  Hence the
             * strange syntax.
             */
            _plugin[_specialFuncName] = function() {
                if (!this.isEnabled()) {
                    return;
                }

                var _mbox = this._createMbox(),
                    _fetcher = new mboxScPluginFetcher(this._clientCode, this.s);

                if (_mbox) {
                    _mbox.setFetcher(_fetcher);
                    _mbox.load();
                }
            };

            _plugin.isEnabled = function() {
                return this._enabled && _factory.isEnabled();
            };

            _plugin._createMbox = function() {
                var _mboxName = this._generateMboxName(),
                    _div = document.createElement('div');

                if (!_helper._isUndefined(document.body)) {
                    document.body.appendChild(_div);
                }

                return _factory.create(_mboxName, [], _div);
            };

            _plugin._generateMboxName = function() {
                var _isPurchase = this.s.events && this.s.events.indexOf('purchase') != -1;

                return 'SiteCatalyst: ' + (_isPurchase ? 'purchase' : 'event');
            };
        };

        return _siteCatalystCore.loadModule(_pluginName);
    }

    _module._mboxLoadSCPlugin = _mboxLoadSCPlugin;
}(TNT._internal));

(function(_module, _helper, _params, _join) {
    var _visitorIdCookieRegExp = new RegExp("\\|MCMID\\|"),
        _delayMboxRequests = false,
        _visitorApiParameters = [],
        _delayedMboxes = [],
        _definedMboxes = [];

    function _getCustomerIdsParameters(_visitor) {
        var _customerIds,
            _keyFunc = function(_key) {
                return 'vst.' + _key;
            };

        if (!_helper._isFunction(_visitor.getCustomerIDs)) {
            return [];
        }

        _customerIds = _visitor.getCustomerIDs();

        if (!_helper._isObject(_customerIds)) {
            return [];
        }

        return _module._extractParamsFromObject(_customerIds, [], _keyFunc);
    }

    function _fireVisitorApiRequest(_visitor, _method, _key) {
        var _notify;

        if (!_helper._isFunction(_visitor[_method])) {
            return;
        }

        _notify = _join._add();

        // We are forcing callback execution for each Visitor API method,
        // this is to ensure an uniform execution, both when data is retrieved from remote server
        // as well as when it is read from cookie
        _visitor[_method](function(_value) {
            _notify({
                key: _key,
                value: _value
            });
        }, true);
    }

    function _populateVisitorApiParameter(_visitor, _method, _key) {
        var _value;

        if (!_helper._isFunction(_visitor[_method])) {
            return;
        }

        _value = _visitor[_method]();

        if (!_helper._isEmpty(_value)) {
            _visitorApiParameters.push({
                key: _key,
                value: _value
            });
        }
    }

    function _executeForEachVisitorApiMethod(_visitor, _func) {
        _func(_visitor, 'getMarketingCloudVisitorID', _params._marketingCloudVisitorId);
        _func(_visitor, 'getAudienceManagerBlob', _params._audienceManagerBlob);
        _func(_visitor, 'getAnalyticsVisitorID', _params._analyticsVisitorId);
        _func(_visitor, 'getAudienceManagerLocationHint', _params._audienceManagerLocationHint);
    }

    function _fireVisitorApiRequests(_visitor) {
        _executeForEachVisitorApiMethod(_visitor, _fireVisitorApiRequest);
    }

    function _populateVisitorApiParameters(_visitor) {
        _executeForEachVisitorApiMethod(_visitor, _populateVisitorApiParameter);
    }

    function _collectVisitorApiParameters(_args) {
        _helper._forEach(_args, function(_arr) {
            _visitorApiParameters.push(_arr[0]);
        });
    }

    function _hasValue(_item) {
        return !_helper._isEmpty(_item.value);
    }

    function _addVisitorApiParameterToUrlBuilder(_item, _urlBuilder) {
        if (!_hasValue(_item)) {
            return;
        }

        _urlBuilder.addParameter(_item.key, _item.value);
    }

    function _addVisitorApiParametersToUrlBuilder(_urlBuilder) {
        _helper._forEach(_visitorApiParameters, function(_item) {
            _addVisitorApiParameterToUrlBuilder(_item, _urlBuilder);
        });
    }

    function _loadDelayedMbox(_factory, _item) {
        var _mbox = _item.mbox;

        if (!_mbox) {
            return;
        }

        switch (_item.type) {
            case 'created':
                // We must use AJAX fetcher for delayed mboxes to make sure we don't wipe the page via document.write()
                _mbox.setFetcher(new mboxAjaxFetcher());
                _mbox.load();
                break;
            case 'defined':
                _factory.update(_mbox.getName(), _item.params);
                break;
        }
    }

    function _fireDelayedMboxRequests(_factory, _visitorApiPageDisplayTimeout) {
        _join._then(function() {
            _delayMboxRequests = false;

            _collectVisitorApiParameters([].slice.call(arguments));
            _addVisitorApiParametersToUrlBuilder(_factory.getUrlBuilder());

            _helper._forEach(_delayedMboxes, function(_item) {
                _addVisitorApiParametersToUrlBuilder(_item.mbox.getUrlBuilder());
                _loadDelayedMbox(_factory, _item);
            });

            setTimeout(_showDocument, _visitorApiPageDisplayTimeout);
        });
    }

    // Exported functions

    function _getVisitorApiClientIfExists(_imsOrgId) {
        var _visitor;

        if (_helper._isEmpty(_imsOrgId) || _helper._isUndefined(window.Visitor) || !_helper._isFunction(window.Visitor.getInstance)) {
            return null;
        }

        _visitor = window.Visitor.getInstance(_imsOrgId);

        if (_helper._isUndefined(_visitor) || _helper._isNull(_visitor) || !_visitor.isAllowed()) {
            return null;
        }

        return _visitor;
    }

    function _shouldExecuteVisitorAPiRequests(_visitor) {
        var _visitorCookie = _visitor.cookieRead(_visitor.cookieName);

        if (_helper._isEmpty(_visitorCookie)) {
            return true;
        }

        return !_visitorIdCookieRegExp.test(_visitorCookie);
    }

    function _executeVisitorApiIfRequired(_factory, _settings) {
        var _imsOrgId = _settings.imsOrgId,
            _visitorApiTimeout = _settings.visitorApiTimeout,
            _visitorApiPageDisplayTimeout = _settings.visitorApiPageDisplayTimeout,
            _urlBuilder = _factory.getUrlBuilder(),
            _visitor;

        if (!_factory.isEnabled()) {
            return;
        }

        _visitor = _getVisitorApiClientIfExists(_imsOrgId);

        if (_helper._isNull(_visitor) || _helper._isUndefined(_visitor.cookieName) || !_helper._isFunction(_visitor.cookieRead)) {
            return;
        }

        _urlBuilder.addParameters(_getCustomerIdsParameters(_visitor));

        if (_shouldExecuteVisitorAPiRequests(_visitor)) {
            _delayMboxRequests = true;

            if (!_helper._isUndefined(_visitor.loadTimeout)) {
                _visitor.loadTimeout = _visitorApiTimeout;
            }

            _setGlobalErrorHandler();
            _hideDocument();
            _fireVisitorApiRequests(_visitor);
            _fireDelayedMboxRequests(_factory, _visitorApiPageDisplayTimeout);
        } else {
            _delayMboxRequests = false;

            _populateVisitorApiParameters(_visitor);
            _addVisitorApiParametersToUrlBuilder(_urlBuilder);
        }
    }

    function _shouldDelayMboxRequest() {
        return _delayMboxRequests;
    }

    function _addDelayedMbox(_item) {
        switch (_item.type) {
            case 'created':
                _delayedMboxes.push(_item);
                break;
            case 'defined':
                _definedMboxes.push(_item);
                break;
        }
    }

    function _isMboxDelayed(_mboxName) {
        var _len = _definedMboxes.length,
            _idx = -1;

        while (++_idx < _len) {
            if (_definedMboxes[_idx].mbox.getName() === _mboxName) {
                return true;
            }
        }

        return false;
    }

    function _processDelayedMbox(_factory, _mboxName, _params) {
        var _visitorApiDataExists = _visitorApiParameters.length > 0,
            _remainingDefinedMboxes = [],
            _len = _definedMboxes.length,
            _idx = -1,
            _urlBuilder,
            _item;

        while (++_idx < _len) {
            _item = _definedMboxes[_idx];
            _urlBuilder = _item.mbox.getUrlBuilder();

            if (_item.mbox.getName() !== _mboxName) {
                _remainingDefinedMboxes.push(_item);
                continue;
            }

            if (!_visitorApiDataExists) {
                _item.params = _params;
                _delayedMboxes.push(_item);
                continue;
            }

            _urlBuilder.addParameters(_params);
            _addVisitorApiParametersToUrlBuilder(_urlBuilder);
            _loadDelayedMbox(_factory, _item);
        }

        _definedMboxes = _remainingDefinedMboxes;
    }

    function _generateSupplementalDataId(_imsOrgId, _clientCode, _mboxName) {
        var _visitor = _getVisitorApiClientIfExists(_imsOrgId);

        if (_helper._isNull(_visitor) || !_helper._isFunction(_visitor.getSupplementalDataID)) {
            return '';
        }

        return _visitor.getSupplementalDataID('mbox:' + _clientCode + ':' + _mboxName);
    }

    function _hideDocument() {
        document.documentElement.style.display = 'none';
        document.documentElement.style.visibility = 'hidden';
    }

    function _showDocument() {
        document.documentElement.style.display = 'block';
        document.documentElement.style.visibility = 'visible';
    }

    function _setStandardErrorListener() {
        if (window.addEventListener) {
            window.addEventListener('error', function _onErrorStandard() {
                _showDocument();
                window.removeEventListener('error', _onErrorStandard);
            });
        }
    }

    function _setInternetExplorerErrorListener() {
        if (window.attachEvent) {
            window.attachEvent('onerror', function _onErrorInternetExplorer() {
                _showDocument();
                window.detachEvent('onerror', _onErrorInternetExplorer);
            });
        }
    }

    function _setGlobalErrorHandler() {
        _setStandardErrorListener();
        _setInternetExplorerErrorListener();
    }

    _module._getVisitorApiClientIfExists = _getVisitorApiClientIfExists;
    _module._executeVisitorApiIfRequired = _executeVisitorApiIfRequired;
    _module._shouldDelayMboxRequest = _shouldDelayMboxRequest;
    _module._addDelayedMbox = _addDelayedMbox;
    _module._isMboxDelayed = _isMboxDelayed;
    _module._processDelayedMbox = _processDelayedMbox;
    _module._generateSupplementalDataId = _generateSupplementalDataId;
}(TNT._internal, TNT._internal._helper, TNT._internal._params, TNT._internal._join));

(function(_module, _internal, _helper, _settings, _params, _constants) {
    function _getGlobalMboxName() {
        return _settings.globalMboxName;
    }

    function _getGlobalMboxLocation() {
        return _settings.globalMboxLocationDomId;
    }

    function _isAutoCreateGlobalMbox() {
        return _settings.globalMboxAutoCreate;
    }

    function _getClientMboxExtraParameters() {
        return _settings.parametersFunction();
    }

    function _getMboxDefaultNode() {
        var _ELEMENT_NODE = 1,
            _nodes = document.getElementsByTagName('script'),
            _node = _nodes[_nodes.length - 1];

        while (_node) {
            if (_node.nodeType === _ELEMENT_NODE && _node.className === _constants._divDefaultClass) {
                return _node;
            }

            _node = _node.previousSibling;
        }

        return null;
    }

    function _mboxCreate(_factory, _mboxName, _params) {
        var _context = TNT._internal,
            _defaultNode,
            _mbox;

        if (_context._shouldDelayMboxRequest()) {
            _defaultNode = _getMboxDefaultNode();
            _mbox = _factory.create(_mboxName, _params, _defaultNode);

            _context._addDelayedMbox({
                mbox: _mbox,
                type: 'created'
            });

            return _mbox;
        } else {
            _mbox = _factory.create(_mboxName, _params);
        }

        if (_mbox && _factory.isEnabled()) {
            _mbox.load();
        }

        return _mbox;
    }

    function _mboxDefine(_factory, _defaultNode, _mboxName, _params) {
        var _context = TNT._internal,
            _mbox = _factory._define(_mboxName, _params, _defaultNode);

        if (_context._shouldDelayMboxRequest()) {
            _context._addDelayedMbox({
                mbox: _mbox,
                type: 'defined'
            });
        }

        return _mbox;
    }

    function _mboxUpdate(_factory, _mboxName, _params) {
        var _context = TNT._internal;

        if (_context._isMboxDelayed(_mboxName)) {
            _context._processDelayedMbox(_factory, _mboxName, _params);
            return;
        }

        _factory.update(_mboxName, _params);
    }

    function _mboxGetCookie(_cookieManager, _name) {
        return _cookieManager.getCookie(_name);
    }

    function _mboxSetCookie(_cookieManager, _name, _value, _duration) {
        _cookieManager.setCookie(_name, _value, _duration);
    }

    function _extractParamsFromQueryString(_queryString) {
        var _result = [];
        var _regex = /([^&=]+)=([^&]*)/g;
        var _decode = decodeURIComponent;
        var _match = _regex.exec(_queryString);

        while (_match) {
            _result.push([_decode(_match[1]), _decode(_match[2])].join('='));
            _match = _regex.exec(_queryString);
        }

        return _result;
    }

    function _extractParamsFromObject(_obj, _keys, _keyFunc) {
        var _result = [];

        for (var _key in _obj) {
            if (!_obj.hasOwnProperty(_key)) {
                continue;
            }

            var _value = _obj[_key];

            if (_helper._isObject(_value)) {
                _keys.push(_key);
                _result = _result.concat(_extractParamsFromObject(_value, _keys, _keyFunc));
                _keys.pop();
            } else {
                if (_keys.length > 0) {
                    _result.push([_keyFunc(_keys.concat(_key).join('.')), _value].join('='));
                } else {
                    _result.push([_keyFunc(_key), _value].join('='));
                }
            }
        }

        return _result;
    }

    function _getTargetPageParameters() {
        var _targetPageParams = window.targetPageParams,
            _keyFunc = function(_key) {
                return _key
            };


        if (!_helper._isFunction(_targetPageParams)) {
            return [];
        }

        var _result = null;

        try {
            _result = _targetPageParams();
        } catch (_ignore) {}

        if (_helper._isNull(_result)) {
            return [];
        }

        if (_helper._isArray(_result)) {
            return _result;
        }

        if (_helper._isString(_result) && !_helper._isEmpty(_result)) {
            return _extractParamsFromQueryString(_result);
        }

        if (_helper._isObject(_result)) {
            return _extractParamsFromObject(_result, [], _keyFunc);
        }

        return [];
    }

    function _createGlobalMbox(_factory) {
        var _globalMboxName = _getGlobalMboxName(),
            _globalMboxDomElementId = _getGlobalMboxLocation(),
            _globalParams = _getTargetPageParameters(),
            _globalMboxDiv,
            _timerId,
            _globalMbox;

        if (!_globalMboxDomElementId) {
            _globalMboxDomElementId = "mbox-" + _globalMboxName + "-" + mboxGenerateId();
            _globalMboxDiv = document.createElement("div");
            _globalMboxDiv.className = "mboxDefault";
            _globalMboxDiv.id = _globalMboxDomElementId;
            _globalMboxDiv.style.visibility = "hidden";
            _globalMboxDiv.style.display = "none";

            _timerId = setInterval(function() {
                if (document.body) {
                    clearInterval(_timerId);
                    document.body.insertBefore(_globalMboxDiv, document.body.firstChild);
                }
            }, _settings.bodyPollingTimeout);
        }

        _globalMbox = _factory.create(_globalMboxName, _globalParams, _globalMboxDomElementId);

        if (TNT._internal._shouldDelayMboxRequest()) {
            TNT._internal._addDelayedMbox({
                mbox: _globalMbox,
                params: [],
                type: 'created'
            });
            return;
        }

        if (_globalMbox && _factory.isEnabled()) {
            if (!_factory.isDomLoaded()) {
                _globalMbox.setFetcher(new _internal._globalMboxFetcher());
            }

            _globalMbox.load();
        }
    }

    function _mboxVizTargetUrl(_factory, _mboxName, _parameters) {
        if (!_factory.isEnabled()) {
            return;
        }

        var _now = new Date(),
            _offset = _now.getTimezoneOffset() * _constants._millisInMinute,
            _urlBuilder = _factory.getUrlBuilder().clone();

        _urlBuilder.setBasePath('/m2/' + _settings.clientCode + '/viztarget');
        _urlBuilder.addParameter(_params._mboxName, _mboxName);
        _urlBuilder.addParameter(_params._mboxId, 0);
        _urlBuilder.addParameter(_params._count, _factory.getMboxes().length() + 1);
        _urlBuilder.addParameter(_params._time, _now.getTime() - _offset);
        _urlBuilder.addParameter(_params._page, mboxGenerateId());
        _urlBuilder.addParameter(_params._domLoaded, _factory.isDomLoaded());

        if (_parameters && _parameters.length > 0) {
            _urlBuilder.addParameters(_parameters);
        }

        _factory._addTntIdIfExists(_urlBuilder);
        _factory._addTargetPageParamsIfRequired(_urlBuilder, _mboxName);
        _factory._addSupplementalDataIfExists(_urlBuilder, _mboxName);

        return _urlBuilder.buildUrl();
    }

    function _createMboxFactories() {
        return new mboxMap();
    }

    function _createMboxFactory(_serverHost, _clientCode, _factoryId) {
        return new mboxFactory(_serverHost, _clientCode, _factoryId);
    }

    // internally exported
    _internal._mboxCreate = _mboxCreate;
    _internal._mboxDefine = _mboxDefine;
    _internal._mboxUpdate = _mboxUpdate;
    _internal._mboxVizTargetUrl = _mboxVizTargetUrl;
    _internal._mboxGetCookie = _mboxGetCookie;
    _internal._mboxSetCookie = _mboxSetCookie;
    _internal._createGlobalMbox = _createGlobalMbox;
    _internal._createMboxFactories = _createMboxFactories;
    _internal._createMboxFactory = _createMboxFactory;
    _internal._extractParamsFromObject = _extractParamsFromObject;

    // globally exported
    _module.getGlobalMboxName = _getGlobalMboxName;
    _module.getGlobalMboxLocation = _getGlobalMboxLocation;
    _module.isAutoCreateGlobalMbox = _isAutoCreateGlobalMbox;
    _module.getClientMboxExtraParameters = _getClientMboxExtraParameters;
    _module.getTargetPageParameters = _getTargetPageParameters;
}(TNT, TNT._internal, TNT._internal._helper, TNT._internal._settings, TNT._internal._params, TNT._internal._constants));

(function(_module) {
    function _showDebugInfoIfRequired(_cookieManager, _settings, _debugParam, _debugCookie) {
        var _DEBUG_TIMEOUT = 60 * 60,
            _isDebugEnabled = mboxGetPageParameter(_debugParam, true) || _cookieManager.getCookie(_debugCookie);

        if (!_isDebugEnabled) {
            return;
        }

        setTimeout(function() {
            if (typeof(window.mboxDebugLoaded) === 'undefined') {
                alert('Could not load the remote debug.\nPlease check your connection to ' + _settings.companyName + ' servers');
            }
        }, _DEBUG_TIMEOUT);

        var _parts = [];

        _parts.push(_settings.adminUrl, '/mbox/mbox_debug.jsp', '?');
        _parts.push('mboxServerHost', '=', _settings.serverHost, '&');
        _parts.push('clientCode', '=', _settings.clientCode);

        document.write('<' + 'scr' + 'ipt src="' + _parts.join('') + '"><' + '\/scr' + 'ipt>');
    }

    function _copySettingsIfExists(_settings, _internalSettings) {
        var _helper = _module._helper,
            _keyExists,
            _valueExists,
            _value;

        if (_helper._isUndefined(_settings) || _helper._isNull(_settings) || !_helper._isObject(_settings)) {
            return _internalSettings;
        }

        for (var _key in _settings) {
            _keyExists = _settings.hasOwnProperty(_key) && _internalSettings.hasOwnProperty(_key);
            _value = _settings[_key];
            _valueExists = !_helper._isUndefined(_value) && !_helper._isNull(_value);

            if (_keyExists && _valueExists) {
                _internalSettings[_key] = _value;
            }
        }

        return _internalSettings;
    }

    function _exportGlobals(_factory, _cookieManager) {
        TNT.createGlobalMbox = function() {
            _module._createGlobalMbox(_factory);
        };

        window.mboxCreate = function(_mboxName /*, ...*/ ) {
            var _params = [].slice.call(arguments, 1);

            return _module._mboxCreate(_factory, _mboxName, _params);
        };

        window.mboxDefine = function(_defaultNode, _mboxName /*, ...*/ ) {
            var _params = [].slice.call(arguments, 2);

            return _module._mboxDefine(_factory, _defaultNode, _mboxName, _params);
        };

        window.mboxUpdate = function(_mboxName /*, ...*/ ) {
            var _params = [].slice.call(arguments, 1);

            _module._mboxUpdate(_factory, _mboxName, _params);
        };

        window.mboxVizTargetUrl = function(_mboxName /*, ...*/ ) {
            var _params = [].slice.call(arguments, 1);

            return _module._mboxVizTargetUrl(_factory, _mboxName, _params);
        };

        window.mboxSetCookie = function(_name, _value, _duration) {
            return _module._mboxSetCookie(_cookieManager, _name, _value, _duration);
        };

        window.mboxGetCookie = function(_name) {
            return _module._mboxGetCookie(_cookieManager, _name);
        };

        // In case SiteCatalyst integration is not enabled we should not
        // export the mboxLoadSCPlugin function
        if (typeof(_module._mboxLoadSCPlugin) !== 'undefined') {
            window.mboxLoadSCPlugin = function(_siteCatalystCore) {
                return _module._mboxLoadSCPlugin(_factory, _siteCatalystCore);
            }
        }
    }

    function _bootstrap() {
        if (typeof(window.mboxVersion) !== 'undefined') {
            return;
        }

        _module._settings = _copySettingsIfExists(window.targetGlobalSettings, _module._settings);

        var _settings = _module._settings,
            _version = _settings.mboxVersion,
            _serverHost = _settings.serverHost,
            _clientCode = _settings.clientCode,
            _defaultFactoryId = _module._constants._defaultFactoryId,
            _debugParam = _module._pageParams._debug,
            _debugCookie = _module._cookies._debug,
            _mboxEdgeServerCookie = _module._cookies._mboxEdgeServer,
            _factory,
            _cookieManager;

        // We should expose these variables to make sure other JS parts have access to them
        window.mboxFactories = _module._createMboxFactories();
        window.mboxFactoryDefault = _factory = _module._createMboxFactory(_serverHost, _clientCode, _defaultFactoryId);
        window.mboxVersion = _version;

        _cookieManager = _factory.getCookieManager();

        _exportGlobals(_factory, _cookieManager);
        _showDebugInfoIfRequired(_cookieManager, _settings, _debugParam, _debugCookie);

        _module._getMboxEdgeServer = function(_mboxServerDefaultValue) {
            var _mboxServer;

            if (!_settings.overrideMboxEdgeServer) {
                return _mboxServerDefaultValue;
            }

            _mboxServer = _cookieManager.getCookie(_mboxEdgeServerCookie);

            return _mboxServer === null ? _mboxServerDefaultValue : _mboxServer;
        }
    }

    _module._bootstrap = _bootstrap;
}(TNT._internal));


TNT._internal._bootstrap();

TNT._internal._executeVisitorApiIfRequired(window.mboxFactoryDefault, TNT._internal._settings);

/*mboxTrack() & mboxTrackLink() & mboxTrackDefer() v4 ==>Mbox.js Extra Javascript*/
var mboxTrack = function(mbox, params) {
        var m, u, i, f = mboxFactoryDefault;
        if (f.isEnabled()) {
            if (f.getMboxes().length() > 0) {
                m = f.getMboxes().getById(0);
                u = m.getURL().replace("mbox=" + escape(m.getName()), "mbox=" + mbox).replace("/undefined", "/ajax").replace("mboxPage=" + f.getPageId(), "mboxPage=" + mboxGenerateId()) + '&' + params, i = new Image();
                i.style.display = 'none';
                i.src = u;
                document.body.appendChild(i)
            } else {
                mboxTrackDefer(mbox, params)
            }
        }
    },
    mboxTrackDefer = function(mbox, params) {
        var f = mboxFactoryDefault;
        if (f.isEnabled()) {
            mboxFactoryDefault.getSignaler().signal(mbox, mbox + '&' + params)
        }
    },
    mboxTrackLink = function(mbox, params, url) {
        mboxTrack(mbox, params);
        setTimeout("location='" + url + "'", 500)
    };
mboxDefine('', 'Customer_Name_onClick');

if (TNT.isAutoCreateGlobalMbox()) {
    TNT.createGlobalMbox();
}

[
    ["mboxCopyright", mboxCopyright],
    ["mboxTrack", mboxTrack],
    ["mboxTrackDefer", mboxTrackDefer],
    ["mboxTrackLink", mboxTrackLink],
    ["TNT", TNT],
    ["tnt_wdpro", tnt_wdpro]
].forEach(function (arr) {
    window[arr[0]] = arr[1];
});
}());}());